<template>
<div>
  <div class="word_1" ref="previewDom">
    <div class="a4">
      <h1 style="font-size:40px;margin-top:100px">
        贵州省建筑业企业优秀
        <br />
      </h1>
      <h1 style="font-size:40px;">项目经理候选人</h1>
      <h1 style="font-size:40px;">申报表</h1>
      <p style="font-size:24px;margin-top:100px">
        <span style="display:inline-block;width:240px">申 报 者 姓 名：</span>
        <span
          style="display:inline-block;width:300px;border-bottom:1px solid black;text-align:center"
        >{{ alldata.candidate.msg1 }}</span> (公章)
      </p>
      <p style="font-size:24px;margin-top:100px">
        <span style="display:inline-block;width:240px">推荐协会(单位):</span>
        <span
          style="display:inline-block;width:300px;border-bottom:1px solid black;text-align:center"
        >{{ alldata.essinfo.msg1 }}</span> (公章)
      </p>
      <p style="font-size:24px;margin-top:100px">
        <span style="display:inline-block;width:240px">候选人所在企业名称:</span>
        <span
          style="display:inline-block;width:300px;border-bottom:1px solid black;text-align:center"
        >{{ alldata.essinfo.msg2 }}</span>(公章)
      </p>
      <p style="font-size:24px;margin-top:100px">
        <span style="display:inline-block;width:240px">联系电话:</span>
        <span
          style="display:inline-block;width:300px;border-bottom:1px solid black;text-align:center"
        >{{ alldata.essinfo.msg3 }}</span>
      </p>
      <p style="text-align:center;margin:100px 0">填报日期: {{ alldata.essinfo.msg4 }}</p>
    </div>
    <div class="a4">
      <div style="display:flex">
        <div>
          <div class="th">
            <div class="td justify-center">姓 名</div>
            <div class="td justify-center">{{ alldata.candidate.msg1 }}</div>
            <div class="td justify-center">性 别</div>
            <div class="td justify-center">{{ alldata.candidate.msg2?alldata.candidate.msg2==1?'男':'女':'' }}</div>
          </div>
          <div class="th">
            <div class="td justify-center">出生年月</div>
            <div class="td justify-center">{{ alldata.candidate.msg3 }}</div>
            <div class="td justify-center">民 族</div>
            <div class="td justify-center" >{{ alldata.candidate.msg4 }}</div>
          </div>
          <div class="th">
            <div class="td justify-center">文化程度</div>
            <div class="td justify-center">{{ alldata.candidate.msg5 }}</div>
            <div class="td justify-center">政治面貌</div>
            <div class="td justify-center">{{ alldata.candidate.msg6 }}</div>
          </div>
          <div class="th">
            <div class="td justify-center">参加工作时间</div>
            <div class="td justify-center">{{ alldata.candidate.msg7 }}</div>
            <div class="td justify-center">专业技术职称</div>
            <div class="td justify-center">{{ alldata.candidate.msg8 }}</div>
          </div>
          <div class="th">
            <div class="td justify-center" style="font-size:14px">注册建造师等级及专业</div>
            <div class="td justify-center">{{ alldata.candidate.msg9 }}</div>
            <div class="td justify-center">职 务</div>
            <div class="td justify-center">{{ alldata.candidate.msg10 }}</div>
          </div>
        </div>
        <div class="td" style="width:140px;border: 1px solid black;">
          <p v-if="!alldata.candidate.msg15" style="text-align:center;line-height:189px">照片</p>
          <img width="140px" height="189px" v-if="alldata.candidate.msg15" :src="alldata.candidate.msg15[0].url" alt="">
        </div>
      </div>

      <div class="th">
        <div class="td justify-center">工作单位</div>
        <div class="long justify-center">{{ alldata.candidate.msg11 }}</div>
      </div>
      <div class="th">
        <div class="td justify-center">单位地址</div>
        <div class="long justify-center">{{ alldata.candidate.msg12 }}</div>
      </div>
      <div class="th">
        <div class="td justify-center">单位电话</div>
        <div class="td t_w180 justify-center">{{ alldata.candidate.msg13 }}</div>
        <div class="td justify-center">邮政编码</div>
        <div class="td t_w180 justify-center">{{ alldata.candidate.msg14 }}</div>
      </div>
      <div class="w_597" style="height:700px">
        <p>近三年内负责的工程名称及所任项目经理职务：</p>
        <p id="condition">{{ alldata.candidate.msg16 }}</p>
      </div>
    </div>
    <div class="a4">
      <div class="w_597" style="height:1100px">
        <p>从事项目管理工作简历、业绩及奖惩情况：</p>
        <p style="height:1100px" id="condition">{{ alldata.candidate.msg17 }}</p>
      </div>
    </div>
    <div class="a4">
      <div
        style="width:720px;font-family:'楷体';font-weight: bolder;font-size:28px;color:black;margin:40px 0"
      >担任项目经理负责施工管理的典型事迹</div>
      <div class="th">
        <div class="td justify-center">工程项目名称</div>
        <div class="long justify-center">{{ alldata.Typicaldeeds.msg1 }}</div>
      </div>
      <div class="th">
        <div class="td justify-center">工程项目地点</div>
        <div class="long justify-center">{{ alldata.Typicaldeeds.msg2 }}</div>
      </div>
      <div class="th">
        <div class="td justify-center">建设单位</div>
        <div class="long justify-center">{{ alldata.Typicaldeeds.msg3 }}</div>
      </div>
      <div class="th">
        <div class="td justify-center">合同工期</div>
        <div class="td t_w180 justify-center">{{ alldata.Typicaldeeds.msg4 }}</div>
        <div class="td justify-center">实际工期</div>
        <div class="td t_w180 justify-center">{{ alldata.Typicaldeeds.msg5 }}</div>
      </div>
      <div class="th">
        <div class="td justify-center">工程概算</div>
        <div class="td t_w180 justify-center">{{ alldata.Typicaldeeds.msg6 }}</div>
        <div class="td justify-center">竣工决算</div>
        <div class="td t_w180 justify-center">{{ alldata.Typicaldeeds.msg7 }}</div>
      </div>
      <div class="w_597" style="height:700px">
        <p>实施项目管理的具体办法：</p>
        <p>{{ alldata.Typicaldeeds.msg8 }}</p>
      </div>
    </div>
    <div class="a4">
      <div class="th">
        <div class="w_60">获市、州级 及以上工程 质量奖获绿 色施工、新 技术应用示 范工程奖名 称及时间</div>
        <div class="w_540" id="condition">{{ alldata.Typicaldeeds.msg9 }}</div>
      </div>
      <div class="th">
        <div class="w_60">获文明施 工现场时 间及授予 部门</div>
        <div class="w_540" id="condition">{{ alldata.Typicaldeeds.msg10 }}</div>
      </div>
      <div class="th">
        <div class="w_60">安 全 生 产 情 况</div>
        <div class="w_540" id="condition">{{ alldata.Typicaldeeds.msg11 }}</div>
      </div>
      <div class="w_597" style="height:300px">
        <p style="font-size:20px">企业推荐意见：</p>
      </div>
    </div>
    <div class="a4">
      <div class="th">
        <div class="w_60" style="height:250px">企 业 主 管 部 门 审 核 意 见</div>
        <div class="w_540" style="height:250px"></div>
      </div>
      <div class="th">
        <div class="w_60" style="height:250px">市、州 建 筑 业协会审查 意 见</div>
        <div class="w_540" style="height:250px"></div>
      </div>
      <div class="th">
        <div class="w_60" style="height:250px">省 评 委 会 评 审 意 见</div>
        <div class="w_540" style="height:250px"></div>
      </div>
      <div class="th">
        <div class="w_60" style="height:250px">省 建 筑 业 协 会 意 见</div>
        <div class="w_540" style="height:250px"></div>
      </div>
    </div>
    <div class="a3">
      <div class="a3-box">
      <div class="box" style="height:50px;width:1094px">
        <h1 style="font-size:24px;margin:0;line-height:50px">2020年度贵州省建筑业企业优秀项目经理推荐评审情况一览表</h1>
      </div>
      <div class="box" style="width:1094px;height:50px;display:flex;justify-content:center;align-items:center;padding:0 10px">
        （排名不分先后）
      </div>
        <div class="th">
          <div class="box justify-center" style="height:60px;width:40px">序号</div>
          <div class="box justify-center" style="height:60px;width:60px">姓名</div>
          <div class="box justify-center" style="height:60px;width:60px">工作单位</div>
          <div class="box justify-center" style="height:60px;width:60px">职务</div>
          <div class="box justify-center" style="height:60px;width:60px">项目经理等级资格</div>
          <div class="box justify-center" style="height:60px;width:240px">任项目经理简历</div>
          <div class="box justify-center" style="height:60px;width:240px">获市级以上工程质量奖、绿色施工、新技术应用示范工程奖名称及时间</div>
          <div class="box justify-center" style="height:60px;width:120px">文明施工现场时间及授予部门</div>
          <div class="box justify-center" style="height:60px;width:60px">安全生产情况</div>
          <div class="box justify-center" style="height:60px;width:60px">企业推荐意见</div>
          <div class="box justify-center" style="height:60px;width:104px">企业主管部门审核意见</div>
        </div>
        <div class="th">
          <div class="box justify-center" style="height:160px;width:40px">1</div>
          <div class="box justify-center" style="height:160px;width:60px">{{ alldata.candidate.msg1 }}</div>
          <div class="box justify-center" style="height:160px;width:60px">{{ alldata.candidate.msg11 }}</div>
          <div class="box justify-center" style="height:160px;width:60px">{{ alldata.candidate.msg10 }}</div>
          <div class="box justify-center" style="height:160px;width:60px">{{ alldata.candidate.msg9 }}:{{ alldata.candidate.msg8 }}</div>
          <div class="box justify-center" style="height:160px;width:240px">{{ alldata.candidate.msg17 }}</div>
          <div class="box justify-center" style="height:160px;width:240px">{{ alldata.Typicaldeeds.msg9 }}</div>
          <div class="box justify-center" style="height:160px;width:120px">{{ alldata.Typicaldeeds.msg10 }}</div>
          <div class="box justify-center" style="height:160px;width:60px">{{ alldata.Typicaldeeds.msg11 }}</div>
          <div class="box justify-center" style="height:160px;width:60px"></div>
          <div class="box justify-center" style="height:160px;width:104px"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="botview">
    <div class="a3">
        <div class="th" style="padding:0 60px">
          <div class="box justify-center" style="width:181px;height:200px">注册建造师证扫描件</div>
          <div class="box justify-center" style="width:181px;height:200px">安全生产考核合格证扫描件</div>
          <div class="box justify-center" style="width:181px;height:200px">获得市（州）级及以上工程质量奖或绿色施工、新技术应用示范工程奖证书扫描件</div>
          <div class="box justify-center" style="width:181px;height:200px">该获奖工程项目经理的任职文件扫描件</div>
          <div class="box justify-center" style="width:181px;height:200px">获得文明施工现场证明材料扫描件</div>
          <div class="box justify-center" style="width:181px;height:200px">企业法人承诺书(原件)  内容应包括: 1、申报资料真实有效有效。2、近三年所完成工程建设项目合格率达到100%， 没有发生过一般及以上工程建设质量安全事故，无拖欠农民工资的行为</div>
          <div class="box justify-center" style="width:181px;height:200px">贵州省优秀项目经理申报表</div>
        </div>
        <div class="th" style="padding:0 60px">
          <div class="box justify-center" style="width:181px;height:200px"><a v-if="alldata.enclosure.msg1" :href="alldata.enclosure.msg1[0].url" target="_blank">有</a></div>
          <div class="box justify-center" style="width:181px;height:200px"><a v-if="alldata.enclosure.msg2" :href="alldata.enclosure.msg2[0].url" target="_blank">有</a></div>
          <div class="box justify-center" style="width:181px;height:200px"><a v-if="alldata.enclosure.msg3" :href="alldata.enclosure.msg3[0].url" target="_blank">有</a></div>
          <div class="box justify-center" style="width:181px;height:200px"><a v-if="alldata.enclosure.msg4" :href="alldata.enclosure.msg4[0].url" target="_blank">有</a></div>
          <div class="box justify-center" style="width:181px;height:200px"><a v-if="alldata.enclosure.msg5" :href="alldata.enclosure.msg5[0].url" target="_blank">有</a></div>
          <div class="box justify-center" style="width:181px;height:200px"><a v-if="alldata.enclosure.msg6" :href="alldata.enclosure.msg6[0].url" target="_blank">有</a></div>
          <div class="box justify-center" style="width:181px;height:200px"><a v-if="alldata.enclosure.msg7" :href="alldata.enclosure.msg7[0].url" target="_blank">有</a></div>
        </div>
    </div>
  </div>
</div>
</template>

<script>
import self_adaption from './adaption'
export default {
  props: {
    alldata: {
      type: Object
    }
  },
  data() {
    return {
      xiahuaxian:"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
    };
  },
  created() {
  },
  mounted() {
    self_adaption()
    this.$emit('previewDom',this.$refs.previewDom)//整页DOM上传至父组件
  }
};
</script>

<style lang="less" scoped>
.word_1{
  width: 841px;
  margin: 0 auto;
}
.a4 {
  padding: 40px 60px;
  width: 842px;
  min-height: 1160px;
  margin: 0 auto;
  margin-top: 32px;
  background: #ffffff;
  box-sizing: border-box;
  color: black;
  p,
  h1 {
    font-family: "仿宋";
  }
  p {
    font-size: 26px;
    display: inline-block;
    width: 100%;
    text-align: start;
  }
  .th {
    display: flex;
    align-items: center;
    font-family: "仿宋";
    .td {
      width: 142px;
      height: 40px;
      box-sizing: border-box;
      border: 1px solid black;
      margin: 0 -1px -1px 0;
      text-align: center;
    }
    .long {
      width: 142px * 4px-3px;
      height: 40px;
      margin: 0 -1px -1px 0;
      border: 1px solid black;
      box-sizing: border-box;
    }
    .t_w180 {
      width: 213px-0.5px;
    }
  }
  .w_597 {
    width: 706px;
    height: 560px;
    padding: 5px 10px;
    border: 1px solid black;
    box-sizing: border-box;
    margin: 0 -1px -1px 0;
    word-break: break-all;
    font-size: 12px;
  }
  .w_60 {
    width: 80px;
    height: 240px;
    border: 1px solid black;
    margin: 0 -1px -1px 0;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    word-break: break-all;
    font-size: 12px;
  }
  .w_540 {
    width: 710px-80px-3px;
    height: 240px;
    border: 1px solid black;
    margin: 0 -1px -1px 0;
    box-sizing: border-box;
    word-break: break-all;
  }
  .justify-center{
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.a3 {
  padding: 40px 0;
  width: 841px;
  height: 1189px;
  margin: 0 auto;
  margin-top: 32px;
  background: #ffffff;
  box-sizing: border-box;
  color: black;
  position: relative;
  .a3-box {
    height: 841px;
    width: 1189px;
    transform: rotate(90deg);
    position: absolute;
    left: -236px;
    top: 200px;
  }
  .th {
    display: flex;
    align-items: center;
    font-family: "仿宋";
  }
  .box {
    box-sizing: border-box;
    border: 1px solid black;
    margin: 0 -1px -1px 0;
    text-align: center;
    font-size: 14px;
    word-break: break-all;
  }
  .justify-center {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .blue {
    &:hover {
      color: rgb(81, 143, 201);
    }
  }
  .justify-start {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: start;
  }
}
</style>
